module.exports = __webpack_public_path__ + "img/medalha-mei.21a21da3.jpg";